import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMembershipbyID } from "../../../redux/membership/action";
import { useParams } from "react-router-dom";

export default function MembershipDetails() {
  const dispatch = useDispatch();
  const membershipbyid = useSelector(
    ({ membership: { membershipbyid } }) => membershipbyid,
  );
  const { id } = useParams();

  useEffect(() => {
    dispatch(getMembershipbyID(id));
  }, [dispatch, id]);

  if (!membershipbyid) {
    return <div>Loading...</div>;
  }

  const { title, description, duration, price, services } = membershipbyid;

  return (
    <div>
      <h2>{title}</h2>
      <p>Description: {description}</p>
      <p>Duration: {duration} months</p>
      <p>Price: ${price}</p>

      <h3>Services:</h3>
      <ul>
        {services?.map((service, index) => (
          <li key={index}>
            <strong>{service.services}</strong> - {service.sub_services} (
            {service.quantity})
          </li>
        ))}
      </ul>
    </div>
  );
}
